import { lazy } from 'react';

import type { RoutesConfig, WrapRoutes } from '@virtuslab/nfs-shared/src/services/routes';

import { MyProfileRoutes } from '../../../config/paths';

const MyProfilePage = lazy(async () => import('.'));

const config: RoutesConfig<WrapRoutes<typeof MyProfileRoutes>> = {
  paths: {
    [MyProfileRoutes.MY_PROFILE]: {
      render: MyProfilePage,
    },
  },
};

export default config;
